import { ArrowRight, Building2 } from 'lucide-react'
import reinzLogoFooter from '@/assets/reinz-logo-footer.png'
import reinzLogoLoginHeader from '@/assets/reinz-logo-login-header.png'
import { Card } from '@/components/ui/card'

interface RoleSelectionScreenProps {
  onSelectAgent: () => void
  onSelectPublic: () => void
  onLearnMore: () => void
}

export function RoleSelectionScreen({ onSelectAgent, onLearnMore }: RoleSelectionScreenProps) {
  return (
    <div className="min-h-screen bg-gradient-hero flex flex-col">
      {/* Header */}
      <div className="flex flex-col items-center justify-center px-6 pt-16 pb-8">
        <div className="mb-6 bg-black p-6">
          <img src={reinzLogoLoginHeader} alt="REINZ" className="w-48 h-auto" />
        </div>

        <h1 className="text-2xl font-bold text-primary-foreground mb-2 text-center font-heading">
          Welcome to REINZ
        </h1>
        <p className="text-primary-foreground/70 text-sm text-center max-w-xs">
          New Zealand's trusted source for real estate information
        </p>
      </div>

      {/* Role Selection Cards */}
      <div className="flex-1 bg-background rounded-t-3xl px-6 pt-8 pb-12 safe-bottom">
        <div className="text-center mb-8">
          <h2 className="text-xl font-semibold text-foreground">How can we help you?</h2>
          <p className="text-sm text-muted-foreground mt-1">
            Member portal for real estate professionals—access market insights, compliance
            resources, data tools, and AskREINZ AI
          </p>
        </div>
        {/* Old source code for the Login buttons */}
        {/* <div className="space-y-4 max-w-md mx-auto"> */}
        {/* Agent Option */}
        {/* <Card 
            onClick={onSelectAgent}
            className="p-6 cursor-pointer card-interactive border-2 border-transparent hover:border-primary group"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center shrink-0">
                <Building2 className="w-7 h-7 text-primary-foreground" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1 flex items-center gap-2">
                Login
                  <ArrowRight className="w-4 h-4 text-primary opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-sm text-muted-foreground">
                  Sign in using your REINZ credentials to unlock member‑only tools and services.
                </p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground">
                For REINZ members with valid credentials
              </p>
            </div>
          </Card> */}

        {/* Public Option */}
        {/* <Card 
            onClick={onSelectPublic}
            className="p-6 cursor-pointer card-interactive border-2 border-transparent hover:border-accent group"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-xl bg-accent flex items-center justify-center shrink-0">
                <Users className="w-7 h-7 text-accent-foreground" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1 flex items-center gap-2">
                  I'm Looking to Buy or Sell
                  <ArrowRight className="w-4 h-4 text-accent opacity-0 group-hover:opacity-100 transition-opacity" />
                </h3>
                <p className="text-sm text-muted-foreground">
                  Find local agents, explore market trends, and get buying & selling guidance
                </p>
              </div>
            </div>
            <div className="mt-4 pt-4 border-t border-border">
              <p className="text-xs text-muted-foreground">
                Free access for everyone
              </p>
            </div>
          </Card> */}
        {/* </div> */}
        {/* Gagan added- New look for Login page        */}
        <div className="space-y-6 max-w-md mx-auto">
          {/* Login Card (clickable) */}
          <Card
            onClick={onSelectAgent}
            className="p-6 cursor-pointer card-interactive border-2 border-transparent hover:border-primary group transition-all"
          >
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center shrink-0">
                <Building2 className="w-7 h-7 text-primary-foreground" />
              </div>

              <div className="flex-1">
                <h3 className="text-lg font-semibold text-foreground mb-1">
                  Authorised REINZ User
                </h3>
                <p className="text-sm text-muted-foreground">
                  Access member tools, insights, compliance resources, and AskREINZ.
                </p>
              </div>
            </div>
          </Card>

          {/* Clean CTA below the card */}
          <button
            onClick={onSelectAgent}
            className="w-full flex items-center justify-center gap-2 bg-primary text-white font-medium py-3 rounded-lg hover:bg-primary/90 transition"
          >
            Login
            <ArrowRight className="w-4 h-4" />
          </button>

          {/* Learn More link */}
          <p className="text-center text-sm text-muted-foreground mt-4">
            Not a member?{' '}
            <button
              onClick={onLearnMore}
              className="text-primary font-medium underline underline-offset-2 hover:text-primary/80 transition"
            >
              Learn more
            </button>
          </p>
        </div>

        {/* Trust Indicators */}
        <div className="mt-10 text-center">
          <p className="text-xs text-muted-foreground mb-4">
            Trusted by New Zealand's real estate industry
          </p>
          <div className="flex items-center justify-center gap-8 text-muted-foreground/60">
            <div className="text-center">
              <p className="text-2xl font-bold text-foreground">16,000+</p>
              <p className="text-xs">Real Estate Professionals</p>
            </div>
            <div className="w-px h-10 bg-border" />
            <div className="text-center">
              <p className="text-2xl font-bold text-foreground">100+</p>
              <p className="text-xs">Years of Trust</p>
            </div>
            <div className="w-px h-10 bg-border" />
            <div className="text-center">
              <p className="text-2xl font-bold text-foreground">NZ-wide</p>
              <p className="text-xs">Coverage</p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-6 text-center">
          <div className="flex items-center justify-center text-xs text-muted-foreground  ">
            <span>Powered by </span>
            <img src={reinzLogoFooter} alt="REINZ" className="w-auto h-6 ml-1" />
          </div>
          <div className="mt-2 mb-1">
            <a
              href="https://www.reinz.co.nz/Web/companion-terms.aspx"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[11px] text-primary hover:underline"
            >
              Terms & Conditions
            </a>
          </div>
          <p className="mt-2 text-[10px] leading-relaxed text-muted-foreground/60 max-w-xs mx-auto">
            © {new Date().getFullYear()} Real Estate Institute of New Zealand (REINZ). All rights
            reserved. This prototype application, including all content, creative materials, and
            intellectual property contained herein, is the exclusive property of REINZ. Unauthorised
            reproduction, distribution, or duplication in any form is strictly prohibited.
          </p>
        </div>
      </div>
    </div>
  )
}
